import i18n from '../../language/index'
/** *****************************************************************************
 * KindEditor - WYSIWYG HTML Editor for Internet
 * Copyright (C) 2006-2011 kindsoft.net
 *
 * @author Roddy <luolonghao@gmail.com>
 * @site http://www.kindsoft.net/
 * @licence http://www.kindsoft.net/license.php
 *******************************************************************************/
import store from '@/vuex/store'

KindEditor.plugin('media', function (K) {
  var self = this, name = 'media', lang = self.lang(name + '.'),
    allowMediaUpload = K.undef(self.allowMediaUpload, true),
    allowFileManager = K.undef(self.allowFileManager, false),
    formatUploadUrl = K.undef(self.formatUploadUrl, true),
    imgPath = 'https://staticjs.71360.com/comcloud/pro/admin/static/kindeditor/plugins/image/images/',
    extraParams = K.undef(self.extraFileUploadParams, {}),
    filePostName = K.undef(self.filePostName, 'imgFile'),
    uploadJson = K.undef(self.uploadJson, self.basePath + 'php/upload_json.php')
  self.plugin.media = {
    edit: function () {
      var html = [
        '<div style="padding:20px;">',
        // url
        '<div class="ke-dialog-row">',
        i18n.t('components_my_rich_text_media_2428'),
        '<label for="keUrl" style="width:60px;">' + lang.url + '</label>',
        '<input class="ke-input-text" type="text" id="keUrl" name="url" value="" style="width:160px;" /> &nbsp;',
        i18n.t('components_my_rich_text_media_2429'),
        '</div>',
        // width
        '<div class="ke-dialog-row">',
        '<label for="keWidth" style="width:60px;">' + lang.width + '</label>',
        '<input type="text" id="keWidth" class="ke-input-text ke-input-number" name="width" value="500" maxlength="4" />',
        '</div>',
        // height
        '<div class="ke-dialog-row">',
        '<label for="keHeight" style="width:60px;">' + lang.height + '</label>',
        '<input type="text" id="keHeight" class="ke-input-text ke-input-number" name="height" value="400" maxlength="4" />',
        '</div>',
        // autostart
        '<div class="ke-dialog-row">',
        '<label for="keAutostart">' + lang.autostart + '</label>',
        '<input type="checkbox" id="keAutostart" name="autostart" value="0" /> ',
        '</div>',
        // poster
        '<div class="ke-dialog-row">',
        '<label for="kePoster">' + lang.poster + '</label>',
        '<span class="selectPoster el-icon el-icon-plus" style="display: inline-block;vertical-align: top;;z-index:1;position: relative;height:80px;width:80px;border:1px #eee dashed;line-height:80px;font-size:20px;text-align: center;">',
        '<span class="mask" style="z-index:2;display:none;position: absolute;left:0;top:0;width:100%;height:100%;background-color:rgba(0,0,0,.3);"></span>',
        i18n.t('components_my_rich_text_media_2430'),
        '<img class="pic" style="position: absolute;left:0;top:0;max-width:100%;max-height:100%;margin:50% 50%;transform: translate(-50% , -50%);"/>',
        i18n.t('components_my_rich_text_media_2431'),
        '<input type="hidden" id="kePoster" name="poster" value=""  /> ',
        '</div>',
        '</div>'
      ].join('')
      console.log(lang)
      var dialog = self.createDialog({
          name: name,
          width: 450,
          height: 350,
          title: self.lang(name),
          body: html,
          yesBtn: {
            name: self.lang('yes'),
            click: function (e) {
              var url = K.trim(urlBox.val()),
                width = widthBox.val(),
                posterUrl = posterBox.val(),
                height = heightBox.val()
              if (url == 'http://' || K.invalidUrl(url)) {
                alert(self.lang('invalidUrl'))
                urlBox[0].focus()
                return
              }
              if (!/^\d*$/.test(width)) {
                alert(self.lang('invalidWidth'))
                widthBox[0].focus()
                return
              }
              if (!/^\d*$/.test(height)) {
                alert(self.lang('invalidHeight'))
                heightBox[0].focus()
                return
              }
              console.log(posterUrl)
              var html = ''
              if (posterUrl) {
                html = K.mediaImg(posterUrl, {
                  src: url,
                  type: K.mediaType(url),
                  width: width,
                  height: height,
                  poster: posterUrl,
                  autostart: autostartBox[0].checked ? 'true' : 'false',
                  loop: 'true'
                })
              } else {
                html = K.mediaImg(imgPath + 'blank.gif', {
                  src: url,
                  type: K.mediaType(url),
                  width: width,
                  height: height,
                  autostart: autostartBox[0].checked ? 'true' : 'false',
                  loop: 'true'
                })
              }
              self.insertHtml(html).hideDialog().focus()
            }
          }
        }),
        div = dialog.div,
        urlBox = K('[name="url"]', div),
        viewServerBtn = K('[name="viewServer"]', div),
        widthBox = K('[name="width"]', div),
        heightBox = K('[name="height"]', div),
        posterBox = K('[name="poster"]', div),
        autostartBox = K('[name="autostart"]', div)
      urlBox.val('http://')
      $('.pageOpne').click(() => {
        store.commit('image_upload/set_fileType', store.state.image_upload.TYPE_VIDEO)
        store.commit('image_upload/set_showTag', true)
        $('.ke-dialog-mask').hide()
        $('.ke-dialog-default').hide()
        store.state.image_upload.imgFile = (e) => {
          console.log(e)
          urlBox.val(e[0].filePath)

          store.state.image_upload.imgFile = null
          $('.ke-dialog-mask').show()
          $('.ke-dialog-default').show()
        }
      })

      widthBox.change(function (e) {
        if (parseInt(this.value, 10) > 2000) {
          this.value = 2000
        }
      })
      heightBox.change(function (e) {
        if (parseInt(this.value, 10) > 2000) {
          this.value = 2000
        }
      })
      $('.selectPoster').mouseenter(() => {
        if (posterBox.val()) {
          $('.mask').show()
          $('.cleanPic').show()
          $('.changePic').show()
        }
      })
      $('.cleanPic').click(() => {
        event.stopPropagation()
        posterBox.val('')
        $('.selectPoster').addClass('el-icon-plus')
        $('.pic').attr('src', '')
        $('.mask').hide()
        $('.cleanPic').hide()
        $('.changePic').hide()
      })
      $('.cleanPic').mousedown(function (e) {
        e.preventDefault()
        event.stopPropagation()
      })
      $('.selectPoster').mouseleave(() => {
        $('.mask').hide()
        $('.cleanPic').hide()
        $('.changePic').hide()
      })
      $('.selectPoster').click(() => {
        store.commit('image_upload/set_fileType', 1)
        store.commit('image_upload/set_showTag', true)
        $('.ke-dialog-mask').hide()
        $('.ke-dialog-default').hide()
        store.state.image_upload.imgFile = (e) => {
          console.log(e)
          posterBox.val(e[0].path)
          $('.pic').attr('src', e[0].path)
          store.state.image_upload.imgFile = null
          $('.el-icon-plus').removeClass('el-icon-plus')
          $('.ke-dialog-mask').show()
          $('.ke-dialog-default').show()
        }
      })
      if (allowMediaUpload) {
        // var uploadbutton = K.uploadbutton({
        // 	button : K('.ke-upload-button', div)[0],
        // 	fieldName : filePostName,
        // 	extraParams : extraParams,
        // 	url : K.addParam(uploadJson, 'dir=media'),
        // 	clickFn : function(data) {
        // 		console.log(2333333333333333)
        // 	},
        // 	afterError : function(html) {
        // 		dialog.hideLoading();
        // 		self.errorDialog(html);
        // 	}
        // });
        // uploadbutton.fileBox.change(function(e) {
        // 	dialog.showLoading(self.lang('uploadLoading'));
        // 	uploadbutton.submit();
        // });
      } else {
        K('.ke-upload-button', div).hide()
      }

      if (allowFileManager) {
        viewServerBtn.click(function (e) {
          self.loadPlugin('filemanager', function () {
            self.plugin.filemanagerDialog({
              viewType: 'LIST',
              dirName: 'media',
              clickFn: function (url, title) {
                if (self.dialogs.length > 1) {
                  K('[name="url"]', div).val(url)
                  if (self.afterSelectFile) {
                    self.afterSelectFile.call(self, url)
                  }
                  self.hideDialog()
                }
              }
            })
          })
        })
      } else {
        viewServerBtn.hide()
      }

      var img = self.plugin.getSelectedMedia()
      if (img) {
        var attrs = K.mediaAttrs(img.attr('data-ke-tag'))
        console.log(attrs)
        urlBox.val(attrs.src)
        widthBox.val(K.removeUnit(img.css('width')) || attrs.width || 0)
        heightBox.val(K.removeUnit(img.css('height')) || attrs.height || 0)
        autostartBox[0].checked = (attrs.autoplay && attrs.autoplay === 'autoplay')
        if (attrs.poster) {
          posterBox.val(attrs.poster)
          $('.el-icon-plus').removeClass('el-icon-plus')
        }
        $('.pic').attr('src', posterBox.val())
      }
      urlBox[0].focus()
      urlBox[0].select()
    },
    'delete': function () {
      self.plugin.getSelectedMedia().remove()
      // [IE] 删除图片后立即点击图片按钮出错
      self.addBookmark()
    }
  }
  self.clickToolbar(name, self.plugin.media.edit)
})



// WEBPACK FOOTER //
// ./src/components/my_rich_text/media.js